import { render, staticRenderFns } from "./ProductAssociates.vue?vue&type=template&id=7b8ae41a&scoped=true"
import script from "./ProductAssociates.vue?vue&type=script&lang=js"
export * from "./ProductAssociates.vue?vue&type=script&lang=js"
import style0 from "./ProductAssociates.vue?vue&type=style&index=0&id=7b8ae41a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8ae41a",
  null
  
)

export default component.exports